import { render, staticRenderFns } from "./DeleteVdDialog.vue?vue&type=template&id=3cf3b0d8&scoped=true"
import script from "./DeleteVdDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteVdDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeleteVdDialog.vue?vue&type=style&index=0&id=3cf3b0d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf3b0d8",
  null
  
)

export default component.exports